import React from 'react';
import PropTypes from 'prop-types';
import InventoryFieldsRow from './InventoryFieldsRow';

/**
 * InventorySection component - Section for Cash/Product/Physical reward types
 * Contains inventory fields (quota, leftover inventory, limit per store)
 * @param {Object} props - Component props
 * @param {Object} props.formData - Form data containing inventory fields
 * @param {Function} props.handleQuotaChange - Function to handle quota field changes
 * @param {Function} props.handleLeftOverInventoryChange - Function to handle leftover inventory field changes
 * @param {Function} props.handleLimitPerStoreChange - Function to handle limit per store field changes
 * @param {Function} props.handleMaxQtyPerOrderChange - Function to handle max quantity per order field changes
 * @param {boolean} props.isQuotaDisabled - Whether quota field should be disabled
 * @param {string} props.quotaValidationError - Validation error message for quota field
 * @param {string} props.limitValidationError - Validation error message for limit per store field
 * @returns {JSX.Element} The rendered InventorySection component
 */
const InventorySection = ({
  formData,
  handleQuotaChange,
  handleLeftOverInventoryChange,
  handleLimitPerStoreChange,
  handleMaxQtyPerOrderChange,
  isQuotaDisabled,
  quotaValidationError,
  limitValidationError,
  maxQtyPerOrderValidationError
}) => {
  return (
    <InventoryFieldsRow
      formData={formData}
      isQuotaDisabled={isQuotaDisabled}
      handleQuotaChange={handleQuotaChange}
      handleLeftOverInventoryChange={handleLeftOverInventoryChange}
      handleLimitPerStoreChange={handleLimitPerStoreChange}
      handleMaxQtyPerOrderChange={handleMaxQtyPerOrderChange}
      quotaValidationError={quotaValidationError}
      limitValidationError={limitValidationError}
      maxQtyPerOrderValidationError={maxQtyPerOrderValidationError}
    />
  );
};

InventorySection.propTypes = {
  formData: PropTypes.shape({
    quota: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    leftOverInventory: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    limitPerStore: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    maxQtyPerOrder: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }).isRequired,
  handleQuotaChange: PropTypes.func.isRequired,
  handleLeftOverInventoryChange: PropTypes.func.isRequired,
  handleLimitPerStoreChange: PropTypes.func.isRequired,
  handleMaxQtyPerOrderChange: PropTypes.func.isRequired,
  isQuotaDisabled: PropTypes.bool,
  quotaValidationError: PropTypes.string,
  limitValidationError: PropTypes.string,
  maxQtyPerOrderValidationError: PropTypes.string
};

export default InventorySection;
